import CommonTable from "@/components/commonTable";
import { calibrateDuolaimuRequest } from "@/service/calibrate";
import { useTable } from "@/utils/useTable";
import { useMemo } from "react";
import { renderBasicCalibrationStatus } from "./status";

interface CalibrateTableDuolaimuProps {
    diagnosisSearchParams: any;
    carId?: number
}


const CalibrateTableDuolaimu = (props: CalibrateTableDuolaimuProps) => {
    const { diagnosisSearchParams = {}, carId } = props;

    const searchParams = useMemo(() => {
        const _params = {
            ...diagnosisSearchParams
        }
        if (carId) {
            _params.carId = carId;
        }
        return _params;
    }, [diagnosisSearchParams, carId]);

    const columns = [
        {
            title: '上报时间',
            dataIndex: 'reportTime'
        },
        {
            title: '参数版本号',
            dataIndex: 'version'
        },
        {
            title: '标定状态',
            dataIndex: 'success',
            render: renderBasicCalibrationStatus
        },
        {
            title: '镜头高度(单位:米)',
            dataIndex: 'cameraMountingHeight'
        },
        {
            title: '设备至车头距离(单位:米)',
            dataIndex: 'frontBumperDistance'
        },
        {
            title: '设备至车右侧距离(单位:米)',
            dataIndex: 'rightSideDistance'
        },
        {
            title: '设备至车左侧距离(单位:米)',
            dataIndex: 'leftSideDistance'
        }
    ] ;
    const { page, limit, loading, data, totalCount, onPageChange } = useTable({
        requestFunc: calibrateDuolaimuRequest,
        initRequest: true,
        initPageSize: 40,
        searchParams
    });

    return (
        <CommonTable
            rowKey="id"
            columns={columns}
            dataSource={data}
            pagination={{
                total: totalCount,
                current: page,
                pageSize: limit,
                onChange: onPageChange
            }}
            bordered
            loading={loading}
            scroll={{ x: '100%', y: 400 }}
        />
    );
};

export default CalibrateTableDuolaimu;
